module.exports = __webpack_public_path__ + "assets/img/page-scroll-tips-a73b7df1.png";